export default "__VITE_ASSET__0bc93107__"